import React from 'react';
import { Upload, Code, History, Check } from 'lucide-react';
import { Button } from '../../../components/ui/button';

interface QuickActionsCardProps {
  onTabChange: (tab: string) => void;
  domainId: string;
  onAddLearning: () => void;
  onCopyEmbed: () => Promise<boolean>;
}

export const QuickActionsCard: React.FC<QuickActionsCardProps> = ({ onTabChange, onAddLearning, onCopyEmbed }) => {
  const [copied, setCopied] = React.useState(false);

  const handleCopyEmbed = async () => {
    const success = await onCopyEmbed();
    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border p-6 mb-6" data-testid="quick-actions-card">
      <h3 className="text-base font-semibold mb-4">クイックアクション</h3>
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" onClick={onAddLearning}>
          <Upload className="h-4 w-4 mr-2" />
          学習データを追加
        </Button>
        <Button variant="outline" onClick={handleCopyEmbed} data-testid="quick-action-copy-embed">
          {copied ? <Check className="h-4 w-4 mr-2" /> : <Code className="h-4 w-4 mr-2" />}
          {copied ? 'コピーしました' : '埋め込みコードをコピー'}
        </Button>
        <Button variant="outline" onClick={() => onTabChange('analytics')}>
          <History className="h-4 w-4 mr-2" />
          チャット履歴を見る
        </Button>
      </div>
    </div>
  );
};
